export const PAYMENT_METHOD_CONFIGS = [
    {
        method: 'gift',
        buttonTestId: 'gcPayment',
        buttonIcon: 'mdi-gift-outline',
        buttonLabelKey: 'cart.payment.giftCard',
        formTitleKey: 'cart.gift.enterDetails',
        formNumberLabelKey: 'giftCard.inputNumber',
        formSerialLabelKey: 'giftCard.inputSerial',
        cardAppliedMessageKey: 'cart.gift.applied',
    },
    {
        method: 'cashless',
        buttonTestId: 'cashlessPayment',
        buttonIcon: 'mdi-cash-usd-outline',
        buttonLabelKey: 'cart.payment.cashless',
        formTitleKey: 'cart.cashless.enterDetails',
        formNumberLabelKey: 'cashless.inputNumber',
        formSerialLabelKey: 'cashless.inputSerial',
        cardAppliedMessageKey: 'cashless.applied',
    },
	{
        method: 'givex',
        buttonTestId: 'givexPayment',
        buttonIcon: 'mdi-gift-outline',
        buttonLabelKey: 'cart.payment.givex',
        formTitleKey: 'givex.details',
        formNumberLabelKey: 'givex.inputNumber',
        formSerialLabelKey: 'givex.inputSerial',
        cardAppliedMessageKey: 'givex.applied',
    }
]
